module.exports = ['component.marketplace.stores.edit.preview.m1'];
